import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

export abstract class AtxBehaviorSubjectModel<T> {
    protected _data = {} as T;
    protected _subject: BehaviorSubject<T> = new BehaviorSubject({} as T);

    protected refresh() {
        this._subject.next(this._data);
    }

    public set data(model) {
        this._data = model;

        this.refresh();
    }

    public get data() {
        return this._data;
    }

    public subject(): Observable<T> {
        return this._subject.asObservable();
    }
}
